<template>
    <div class="onboarding">
        <div class="popup__header popup__header--border">
            <span class="title title--sm popup__title">{{ $lang('MasterOnboarding.title') }}</span>
        </div>

        <div class="onboarding__block">
            <div class="title title--xs title--bold">
                <p>{{ $lang('MasterOnboarding.step1.title') }}</p>

                <p>{{ $lang('MasterOnboarding.step1.subititle') }}</p>
            </div>

            <p class="onboarding__text">{{ $lang('MasterOnboarding.step1.text') }}</p>

            <iframe
                class="onboarding__video"
                :src="Vue.prototype.$lang('MasterOnboarding.instructions.link')"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            >
            </iframe>
        </div>

        <div class="onboarding__block">
            <div class="title title--xs title--bold">
                <p>{{ $lang('MasterOnboarding.step2.title') }}</p>

                <p>{{ $lang('MasterOnboarding.step2.subititle') }}</p>
            </div>

            <p class="onboarding__text">{{ $lang('MasterOnboarding.step2.text1') }}</p>

            <div class="onboarding__text onboarding__text--mt-1">
                <p>{{ $lang('MasterOnboarding.step2.text2') }}</p>

                <p>{{ $lang('MasterOnboarding.step2.text3') }}</p>

                <p>{{ $lang('MasterOnboarding.step2.text4') }}</p>

                <p>{{ $lang('MasterOnboarding.step2.text5') }}</p>
            </div>

            <p class="onboarding__text onboarding__text--mt-1">{{ $lang('MasterOnboarding.step2.text6') }}</p>

            <p class="onboarding__text onboarding__text--mt-1">{{ $lang('MasterOnboarding.step2.text7') }}</p>
        </div>

        <div class="onboarding__block">
            <div class="title title--xs title--bold">
                <p>{{ $lang('MasterOnboarding.step3.title') }}</p>

                <p>{{ $lang('MasterOnboarding.step3.subititle') }}</p>
            </div>

            <div class="onboarding__text">
                <p class="title title--bold">{{ $lang('MasterOnboarding.step3.text1') }}</p>

                <div class="onboarding__text">
                    <p>{{ $lang('MasterOnboarding.step3.text2') }}</p>

                    <p>{{ $lang('MasterOnboarding.step3.text3') }}</p>

                    <p>{{ $lang('MasterOnboarding.step3.text4') }}</p>
                </div>

                <p class="onboarding__text">{{ $lang('MasterOnboarding.step3.text5') }}</p>
            </div>

            <div class="onboarding__text">
                <p class="title title--bold">{{ $lang('MasterOnboarding.step3.text6') }}</p>

                <p class="onboarding__text">{{ $lang('MasterOnboarding.step3.text7') }}</p>

                <p class="onboarding__text">{{ $lang('MasterOnboarding.step3.text8') }}</p>
            </div>

            <div class="onboarding__text">
                <p class="title title--bold">{{ $lang('MasterOnboarding.step3.text9') }}</p>

                <p class="onboarding__text">{{ $lang('MasterOnboarding.step3.text10') }}</p>
            </div>

            <div class="onboarding__text">
                <p class="title title--bold">{{ $lang('MasterOnboarding.step3.text11') }}</p>

                <p class="onboarding__text">{{ $lang('MasterOnboarding.step3.text12') }}</p>
            </div>

            <p class="onboarding__text">{{ $lang('MasterOnboarding.step3.text13') }}</p>
        </div>

        <div class="onboarding__block onboarding__block--no-border" v-if="user && !user.master_data.onboarding_accepted">
            <form dusk="confirm"  @submit.prevent="onSubmit">
                <el-popover v-model="errors.checked.isError"
                            trigger="manual"
                            placement="top"
                            width="200"
                            popper-class="add__error-popover"
                            :content="errors.checked.message">
                    <el-checkbox slot="reference"
                                 dusk='confirm-checkbox'
                                 class="el-checkbox--width-content"
                                 :class="{ 'add__error': errors.checked.isErrorPaint }"
                                 @input="clearErrors"
                                 v-model="form.checked"
                                 required
                    >
                        {{ $lang('MasterOnboarding.form.checkbox') }}
                    </el-checkbox>
                </el-popover>

                <button
                    dusk="confirm-button"
                    class="btn btn--big btn--main-bg hero__link hero__create onboarding__btn"
                    :class="{ 'btn--w100': windowWidth < 500 }"
                >
                    <span>{{ $lang('MasterOnboarding.form.button') }}</span>
                </button>
            </form>

            <p class="onboarding__hint">{{ $lang('MasterOnboarding.form.hint') }}</p>
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";
import ApiService from "../../../api/api";
import errors from "../../../mixins/errors"
import Vue from "vue";

export default {
    computed: {
        Vue() {
            return Vue
        }
    },
    mixins: [errors],
    data() {
        return {
            user: window.laravel.user,
            form: {
                blocked: false,
                checked: false,
            },
            errors: {
                checked: {
                    isError: false,
                    message: ''
                },
            },
        }
    },
    mounted() {
        this.setModal(850);
    },
    methods: {
        ...mapMutations('create', ['setModal']),
        onSubmit() {
            if (this.form.blocked) {
                return;
            }

            this.form.blocked = true;

            this.$loading(this.$optionsLoading);

            ApiService.post('/master/check-onboarding', this.form)
                .then(() => {
                    window.location.href = window.laravel.prefix + '/page';
                    return;
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.form.blocked = false;
                    this.$loading({}).close();
                });
        }
    },
}
</script>
